export default __webpack_public_path__ + "static/media/sampleMapLocationMonitoring.3a4ac5fe.png";